import { useLanguageContext } from "../../../context/LanguageContext";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import { StyledInput } from "../../../styles/InputStyles";
import { useAuthContext } from "../../../context/AuthContext";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import FormContainer from "../../../components/formContainer/FormContainer";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import Select from "../../../components/select/main/Select";
import MultiSelect from "../../../components/select/main/multi/MultiSelect";
import LocationFormSelect from "../../../components/select/custom/location/form/LocationFormSelect";
import LanguageFormSelect from "../../../components/select/custom/language/form/LanguageFormSelect";
import { StyledFlexColumn } from "../../../styles/LayoutStyles";

function UserPageView({
  user,
  userData,
  passwordUpdateOnly,
  roles,
  employees,
  onLocationIdChange,
  onNameChange,
  onEmailChange,
  onPasswordChange,
  onLanguageIdChange,
  onEmployeeIdChange,
  onRolesChange,
  onUseTfaChange,
  onCancel,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();
  const authContext = useAuthContext();

  return (
    <OverlayLoader groups="user_page_fetch">
      <FormContainer
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"user_page_save"}
      >
        <StyledFlexColumn>
          {authContext.auth.user.company.type !== "superadmin" ? (
            <InputWrapper
              label={translate("eva.main.entities.location")}
              error={EVAApiHelper.getResponseError("location_id", submitError)}
            >
              <LocationFormSelect
                value={userData.location_id}
                onChange={onLocationIdChange}
                disabled={user !== undefined || passwordUpdateOnly}
              />
            </InputWrapper>
          ) : (
            ""
          )}

          <InputWrapper
            label={translate("eva.main.validation.attributes.name")}
            error={EVAApiHelper.getResponseError("name", submitError)}
            required
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.name")}
              value={userData.name}
              onChange={onNameChange}
              disabled={passwordUpdateOnly}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.email")}
            error={EVAApiHelper.getResponseError("email", submitError)}
            required
          >
            <StyledInput
              type="email"
              placeholder={translate("eva.main.validation.placeholders.email")}
              value={userData.email}
              onChange={onEmailChange}
              disabled={passwordUpdateOnly}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.language_id")}
            error={EVAApiHelper.getResponseError("language_id", submitError)}
            required
          >
            <LanguageFormSelect
              value={userData.language_id}
              onChange={onLanguageIdChange}
              disabled={passwordUpdateOnly}
            />
          </InputWrapper>

          {authContext.auth.user.company.type !== "superadmin" ? (
            <>
              <InputWrapper
                label={translate("eva.main.entities.employee")}
                error={EVAApiHelper.getResponseError(
                  "employee_id",
                  submitError,
                )}
              >
                <Select
                  options={employees.map((employee) => {
                    return { value: employee.id, label: employee.name };
                  })}
                  value={userData.employee_id}
                  nullable
                  onChange={onEmployeeIdChange}
                  disabled={passwordUpdateOnly}
                />
              </InputWrapper>

              <InputWrapper
                label={translate("eva.main.validation.attributes.use_tfa")}
                error={EVAApiHelper.getResponseError("use_tfa", submitError)}
              >
                <Select
                  options={[
                    { value: true, label: translate("eva.main.general.yes") },
                    { value: false, label: translate("eva.main.general.no") },
                  ]}
                  value={userData.use_tfa}
                  onChange={onUseTfaChange}
                  disabled={passwordUpdateOnly}
                />
              </InputWrapper>

              <InputWrapper
                label={translate("eva.main.entities.roles")}
                error={EVAApiHelper.getResponseErrorArray(
                  "roles",
                  submitError,
                  (index) => roles[index].name,
                )}
              >
                <MultiSelect
                  options={roles.map((role) => {
                    return { value: role.id, label: role.name };
                  })}
                  value={userData.roles}
                  onChange={onRolesChange}
                  disabled={passwordUpdateOnly}
                />
              </InputWrapper>
            </>
          ) : (
            ""
          )}
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default UserPageView;
